
import React, {useEffect, useState} from 'react';
import { Notification} from "../../../../utils";
import HelpMessagesSidebar from './HelpMessagesSidebar';
import {helpMessageItemsActions, helpMessagesActions, useSelector} from 'inbooma-api';
import HelpMessagesList from './HelpMessagesList';
import SortNav from '../../../components/SortNav';
import {$, _} from "../../../../../vendor";
import Paginator from "../../../components/paginator";
import Loader from "../../../components/Loader";
import EditHelpMessage from "./EditHelpMessage";
import EditHelpMessageItem from "./EditHelpMessageItem";

const HelpMessagesView = (props) => {
    const { params, name, dispatch, returnPath, rbac,t, Biscuit, language,
        helpMessageEdit,
        helpMessageAdd,
        helpMessageId,
        helpMessageItemEdit,
        helpMessageItemAdd,
        helpMessageItemId} = props;
    const [initialized,setInitialized] = useState(false);
    const [filter,setFilter] = useState({});
    const [sort,setSort] = useState({
        sort: "created",
        direction: "desc"
    });
    const [pagination,setPagination] = useState({
        has_next_page: false,
        current_page: 1
    });
    const paginationLimit = 40;
    const [helpMessages,setHelpMessages] = useState([]);
    const [helpMessagesPending,setHelpMessagesPending] = useState(false);
    const [helpMessage,setHelpMessage] = useState([]);
    const [helpMessagePending,setHelpMessagePending] = useState(false);
    const [helpMessageDeletePending,setHelpMessageDeletePending] = useState(false);
    const [helpMessageItem,setHelpMessageItem] = useState([]);
    const [helpMessageItemPending,setHelpMessageItemPending] = useState(false);
    const [addHelpMessage, setAddHelpMessage] = useState(helpMessageAdd);
    const [addHelpMessageItem, setAddHelpMessageItem] = useState(helpMessageItemAdd);
    const _helpMessages = useSelector(state => state.help_messages_data.getHelpMessages);
    const _helpMessage = useSelector(state => state.help_messages_data.getHelpMessage);

    const _deleteHelpMessage = useSelector(state => state.help_messages_data.deleteHelpMessage);
    const _helpMessageItem = useSelector(state => state.help_message_items_data.getHelpMessageItem);

    useEffect(() => {
                if (_helpMessages.success === "" || !helpMessagesPending) return;
                
                if (_helpMessages.success === true) {
                        setHelpMessages(_helpMessages.data);
                        setPagination({..._helpMessages.pagination});

                    //setPagination({..._salesBillings.pagination});
                } else {
                  console.log("Failed fetching help_messages!");
                }
                setHelpMessagesPending(false);
    },[_helpMessages]);

    useEffect(() => {
        if (_helpMessage.success === "" || !helpMessagePending) {
            return;
        }
        if (_helpMessage.success === true) {
            setHelpMessage(_helpMessage.data);

            //setPagination({..._salesBillings.pagination});
        } else {
            console.log("Failed fetching help_message!");
        }
        setHelpMessagePending(false);
    },[_helpMessage]);


    useEffect(() => {
        if (_helpMessageItem.success === "" || !helpMessageItemPending) {
            return;
        }
        if (_helpMessageItem.success === true) {
            setHelpMessageItem(_helpMessageItem.data);

            //setPagination({..._salesBillings.pagination});
        } else {
            console.log("Failed fetching help_message item!");
        }
        setHelpMessageItemPending(false);
    },[_helpMessageItem]);

    useEffect(() => {
        if (_deleteHelpMessage.success === '' || !helpMessageDeletePending){
            return;
        }
        if(_deleteHelpMessage.success === true){
            filterChangedHandle(filter);
        }
        setHelpMessageDeletePending(false);
    }, [_deleteHelpMessage]);
    const deleteHelpMessage = (helpMessage) => {
        dispatch(helpMessagesActions.deleteHelpMessage({
            "token": Biscuit.get("token"),
            "id": helpMessage.id
        }));
        setHelpMessageDeletePending(true);
    }

    const filterChangedHandle = (filter) => {

        let requestFilter = {...filter};
        requestFilter.sort = sort.sort;
        requestFilter.direction = sort.direction;
        requestFilter.limit = paginationLimit;
        requestFilter.page = 1;

        props.dispatch(helpMessagesActions.getHelpMessages({
            token: Biscuit.get('token'),
            suffix: "",
            filter: requestFilter,
            parameters: {
                headers: {
                    'Accept-Language': language,
                    'Content-Language': language
                }
            }
        }));
        setHelpMessagesPending(true);
        setFilter(filter);
    };

    const onSortChangedHandle = (ev) => {
        const el = ev.currentTarget;

        const sortKey = el.getAttribute('data-inb-val'),
            direction = el.getAttribute('data-inb-direction'),
            isOppositeElement = (direction === null && el.classList.contains('is-active')),
            newDirection = (direction === 'desc' || isOppositeElement ? 'asc' : 'desc');

        if (sortKey) {
            let requestFilter;
            if(typeof filter.limit !== 'undefined') {
                requestFilter = {
                    ...filter,
                    sort: sortKey,
                    direction: direction
                };
            } else {
                requestFilter = {
                    ...filter,
                    sort: sortKey,
                    direction: direction,
                    limit: paginationLimit,
                    page: 1
                };
            }

            props.dispatch(helpMessagesActions.getHelpMessages({
                token: Biscuit.get('token'),
                suffix: "",
                filter: requestFilter,
                parameters: {
                    headers: {
                        'Accept-Language': language,
                        'Content-Language': language
                    }
                }
            }));
            setHelpMessagesPending(true);
            setSort({
                sort: sortKey,
                direction: direction
            });

            const activeSortTab = $('.is-active');
            _.each(activeSortTab, function(key){
                key.classList.remove('is-active');
            });
            el.classList.add('is-active');
            el.setAttribute('data-inb-direction', (isOppositeElement ? 'desc' : newDirection));
        }
    };

    const showNotification = (msgType, itemId, errorMsg ='',type='helpMessage') => {

        if (msgType === 'success') {
            new Notification({
                message : t('saved_${a}',{a:t(type)},'capital')+' #'+ itemId,
                duration : 5000,
                type : 'success',
                closeable : true,
                icon : 'fi fi-check'
            });
        } else if (msgType === 'warning') {
            new Notification({
                message : errorMsg,
                duration : 5000,
                type : 'warning',
                closeable : true,
                icon : 'fi fi-x'
            });
        }
    };

    const initialize = () => {
        if(helpMessagesPending || helpMessagePending) return;
        props.dispatch(helpMessagesActions.getHelpMessages({
            token: Biscuit.get('token'),
            suffix: "",
            filter: {
                sort: sort.sort,
                direction: sort.direction,
                limit: paginationLimit,
                page: 1
            },
            parameters: {
                headers: {
                    'Accept-Language': language,
                    'Content-Language': language
                }
            }
        }));  
        setHelpMessagesPending(true);
        if(helpMessageId !== null){
            props.dispatch(helpMessagesActions.getHelpMessage({
                token: Biscuit.get('token'),
                id: helpMessageId,
                parameters: {
                    headers: {
                        'Accept-Language': language,
                        'Content-Language': language
                    }
                }
            }));
            setHelpMessagePending(true);
        }
        if(helpMessageItemEdit && helpMessageItemId !== null){
            props.dispatch(helpMessageItemsActions.getHelpMessageItem({
                token: Biscuit.get('token'),
                id: helpMessageItemId,
                parameters: {
                    headers: {
                        'Accept-Language': language,
                        'Content-Language': language
                    }
                }
            }));
            setHelpMessageItemPending(true);
        }
        setInitialized(true);
    };

    if (initialized === false) initialize();

    let tabs =[{
        name: t('screen',null,'capital'),
        smallWidth: 2,
        mediumWidth: 1,
        title: t('sort_by_${a}',{a:t('screen')},'capital'),
        canSort: true,
        sort: {
          direction: 'asc',
          data_inb_val: 'screen'
        }
      },{
        name: t('client',null,'capital'),
        smallWidth: 2,
        mediumWidth: 1,
        title: t('client',null,'capital'),
        canSort: true,
        sort: {
            direction: 'asc',
            data_inb_val: 'client_id'
        }
      }
    ];

    const loadNextPage = (page) => {

        //if (!pagination.has_next_page) return;

        setHelpMessagesPending(true);

        let requestFilter = {...filter};
        requestFilter.sort = sort.sort;
        requestFilter.direction = sort.direction;
        requestFilter.limit = paginationLimit;
        requestFilter.page = page;

        // fetch next page
        props.dispatch(helpMessagesActions.getHelpMessages({
            token: Biscuit.get('token'),
            suffix: "",
            filter: requestFilter,
            parameters: {
                headers: {
                    'Accept-Language': language,
                    'Content-Language': language
                }
            }
        }));
    };


    return (
        <>
            <HelpMessagesSidebar
                dispatch={dispatch}
                heading={name}
                rbac={rbac}
                initialized={initialized}
                sort={sort}
                setSort={setSort}
                t={t}
                name={name}
                Biscuit={Biscuit}
            />
            <div id='inb-c-main' className='columns'>
                <SortNav
                    tabs={tabs}
                    listStyle="tight"
                    handler={onSortChangedHandle}/>
                {initialized && helpMessages.length > 0 && !helpMessagesPending && typeof pagination !== 'undefined' &&
                    <>
                    <Paginator
                        pagination={pagination}
                        itemsCountPerPage={paginationLimit}
                        pageRangeDisplayed={5}
                        onChange={loadNextPage}
                    />
                <HelpMessagesList
                    helpMessages={helpMessages}
                  dispatch={dispatch}
                  currentUrl={new URL(window.location.href)}
                  showNotification={showNotification}
                    deleteHelpMessage={deleteHelpMessage}

                />
                        <Paginator
                            pagination={pagination}
                            itemsCountPerPage={paginationLimit}
                            pageRangeDisplayed={5}
                            onChange={loadNextPage}
                        /></>}
                {helpMessagesPending  && <Loader
                    mediumWidth={2}
                    smallWidth={4}
                    subLoaders={5}/>}
                {(initialized && (helpMessages.length < 1 || typeof helpMessages.length === 'undefined') && !helpMessagesPending) &&
                    <>
                        <div
                            id="inb-app-collection-empty"
                            className="inb-announcement">
                            <div className="inb-image-box">
                                <img src="assets/img/no_data.svg"/>
                            </div>
                            <h3>
                                { t('app_msg_collection_empty') }
                            </h3>
                            <p>
                                { t('app_msg_collection_empty_body') }
                            </p>
                        </div>
                    </>
                }
            </div>
            {initialized && (addHelpMessage || (helpMessageEdit && !helpMessagePending)) &&
                <EditHelpMessage
                    dispatch={dispatch}
                    helpMessage={helpMessage}
                    language={language}
                    params={params}
                    setAddHelpMessage={setAddHelpMessage}
                    requestPath={returnPath}
                    showNotification={showNotification}
                    filterChangedHandle={filterChangedHandle}
                    filter={filter}
                    currentUrl={new URL(window.location.href)}
                    //dispatch, helpMessage, showNotification, setAddHelpMessage, filter, filterChangedHandle, requestPath, currentUrl, language
                />
            }
            {initialized && !helpMessagePending && (addHelpMessageItem || (helpMessageItemEdit && !helpMessageItemPending)) &&
                <EditHelpMessageItem
                    dispatch={dispatch}
                    helpMessage={helpMessage}
                    helpMessageItem={helpMessageItem}
                    language={language}
                    params={params}
                    setAddHelpMessageItem={setAddHelpMessageItem}
                    requestPath={returnPath}
                    showNotification={showNotification}
                    filterChangedHandle={filterChangedHandle}
                    filter={filter}
                    currentUrl={new URL(window.location.href)}
                    //dispatch, helpMessage, showNotification, setAddHelpMessage, filter, filterChangedHandle, requestPath, currentUrl, language
                />
            }
        </>
    );
};

export default HelpMessagesView;